import React from "react";
import { NavLink as RrdNavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function NavLink({ to, ...props }) {
  const [, i18n] = useTranslation();
  const localTo = `/${i18n.language}${to === "/" ? "" : to}`;
  return <RrdNavLink to={localTo} {...props} />;
}
